module.exports = __webpack_public_path__ + "img/gift4-01-c09-k2.590c052f.png";